var make = require('./make_');
var arrReduce = require('../array/reduce');
var objReduce = require('../object/reduce');

    /**
     */
    module.exports = make(arrReduce, objReduce);





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/reduce.js
// module id = 1578
// module chunks = 0 1 2